var map = {
	"./02 Welcome Screen – 1.png": 189,
	"./02 Welcome Screen – 1@2x.png": 190,
	"./02 Welcome Screen – 1@3x.png": 191,
	"./04 Personal Details – 1.png": 192,
	"./04 Personal Details – 1@2x.png": 193,
	"./04 Personal Details – 1@3x.png": 194,
	"./04PersonalDetails-1.png": 195,
	"./14 KYCDetails – 2.png": 196,
	"./14 KYCDetails – 2@2x.png": 197,
	"./14 KYCDetails – 2@3x.png": 198,
	"./14 ProfessionalDetails – 1.png": 199,
	"./14 ProfessionalDetails – 1@2x.png": 200,
	"./14 ProfessionalDetails – 1@3x.png": 201,
	"./14KYCDetailsTataNeu2.png": 202,
	"./14KYCDetailsTataNeu2@2x.png": 203,
	"./14KYCDetailsTataNeu2@3x.png": 204,
	"./14KYCDetailsYono2.png": 205,
	"./14KYCDetailsYono2@2x.png": 206,
	"./14KYCDetailsYono2@3x.png": 207,
	"./3.1 System Error 01.png": 208,
	"./Add-credit-card@2x.png": 209,
	"./Background-TataNeu.png": 210,
	"./Background.png": 211,
	"./BackgroundTataNeu.png": 212,
	"./BackgroundYono.png": 213,
	"./CADIcon-Yono.png": 214,
	"./CADIcon.png": 215,
	"./CADScreen.png": 216,
	"./CADScreen@2x.png": 217,
	"./EKYCContinue.png": 218,
	"./EKYCContinue@2x.png": 219,
	"./EKYCStatus.png": 220,
	"./EKYCStatus@2x.png": 221,
	"./Ellipse4.png": 222,
	"./Ellipse4@2x.png": 223,
	"./Group -106.png": 224,
	"./Group -106@2x.png": 225,
	"./Group -11.png": 226,
	"./Group -11@2x.png": 227,
	"./Group -12-TataNeu.png": 228,
	"./Group -12-TataNeu@2x.png": 229,
	"./Group -12-Yono.png": 230,
	"./Group -12-Yono@2x.png": 231,
	"./Group -12.png": 232,
	"./Group -12@2x.png": 233,
	"./Group -12TataNeu@2x.png": 234,
	"./Group -16.png": 235,
	"./Group -3.png": 236,
	"./Group -3@2x.png": 237,
	"./Group -4.png": 238,
	"./Group -4@2x.png": 239,
	"./Group -5.png": 240,
	"./Group -5@2x.png": 241,
	"./Group -6.png": 242,
	"./Group -65.png": 243,
	"./Group -65@2x.png": 244,
	"./Group -6@2x.png": 245,
	"./Group -6TataNeu.png": 246,
	"./Group -6TataNeu@2x.png": 247,
	"./Group -8.png": 248,
	"./Group -8@2x.png": 249,
	"./Group 1278.png": 250,
	"./Group 1278@2x.png": 251,
	"./Group 1284.png": 252,
	"./Group 1284@2x.png": 253,
	"./Group 1284TataNeu.png": 254,
	"./Group 1284TataNeu@2x.png": 255,
	"./Group 1284Yono.png": 256,
	"./Group 1284Yono@2x.png": 257,
	"./Group 1285.png": 258,
	"./Group 1285@2x.png": 259,
	"./Group 1285TataNeu.png": 260,
	"./Group 1285TataNeu@2x.png": 261,
	"./Group 1285Yono.png": 262,
	"./Group 1285Yono@2x.png": 263,
	"./Group 1302.png": 264,
	"./Group 1302@2x.png": 265,
	"./Group 1489.png": 266,
	"./Group 1489@2x.png": 267,
	"./Group 1542.png": 268,
	"./Group 1542@2x.png": 269,
	"./Group 1614.png": 270,
	"./Group 1614@2x.png": 271,
	"./Group 1651.png": 272,
	"./Group 167.png": 273,
	"./Group 167@2x.png": 274,
	"./Group 1691.png": 275,
	"./Group 1691@2x.png": 276,
	"./Group 1692.png": 277,
	"./Group 1692@2x.png": 278,
	"./Group 1693.png": 279,
	"./Group 1693@2x.png": 280,
	"./Group 1715.png": 281,
	"./Group 1715@2x.png": 282,
	"./Group 1722.png": 283,
	"./Group 1722@2x.png": 284,
	"./Group 1884.png": 285,
	"./Group 1884@2x.png": 286,
	"./Group 1884@3x.png": 287,
	"./Group 1961.png": 288,
	"./Group 1961@2x.png": 289,
	"./Group 2032.png": 290,
	"./Group 2032@2x.png": 291,
	"./Group 2032@3x.png": 292,
	"./Group 2072.png": 293,
	"./Group 2166.png": 294,
	"./Group 2166@2x.png": 295,
	"./Group 2575.png": 296,
	"./Group 2575@2x.png": 297,
	"./Group 2661.png": 298,
	"./Group 2661@2x.png": 299,
	"./Group 2664.png": 300,
	"./Group 2664@2x.png": 301,
	"./Group 2820@2x.png": 302,
	"./Group 2978.png": 303,
	"./Group 2978@2x.png": 304,
	"./Group 3024.png": 305,
	"./Group 3024@2x.png": 306,
	"./Group 3026.png": 307,
	"./Group 3026@2x.png": 308,
	"./Group 3032.png": 309,
	"./Group 3032@2x.png": 310,
	"./Group 3039.png": 311,
	"./Group 3039@2x.png": 312,
	"./Group 3041.png": 313,
	"./Group 3041@2x.png": 314,
	"./Group 3053.png": 315,
	"./Group 3053@2x.png": 316,
	"./Group 3054.png": 317,
	"./Group 3054@2x.png": 318,
	"./Group 3056.png": 319,
	"./Group 3056@2x.png": 320,
	"./Group 3057.png": 321,
	"./Group 3057@2x.png": 322,
	"./Group 3321 mob.png": 323,
	"./Group 3321 mob@2x.png": 324,
	"./Group 3377.png": 325,
	"./Group 3377@2x.png": 326,
	"./Group 3379.png": 327,
	"./Group 3379@2x.png": 328,
	"./Group 3380.png": 329,
	"./Group 3380@2x.png": 330,
	"./Group 3381.png": 331,
	"./Group 3381@2x.png": 332,
	"./Group 3398.png": 333,
	"./Group 3398@2x.png": 334,
	"./Group 3402.png": 335,
	"./Group 3403.png": 336,
	"./Group 3404.png": 337,
	"./Group 3405.png": 338,
	"./Group 3406.png": 339,
	"./Group 3406@2x.png": 340,
	"./Group 3406_blue.png": 341,
	"./Group 3406_blue@2x.png": 342,
	"./Group 3419.png": 343,
	"./Group 3419@2x.png": 344,
	"./Group 3453.png": 345,
	"./Group 3453@2x.png": 346,
	"./Group 405.png": 347,
	"./Group 405@2x.png": 348,
	"./Group 405@3x.png": 349,
	"./Group 485.png": 350,
	"./Group 485@2x.png": 351,
	"./Group 607.png": 352,
	"./Group 607@2x.png": 353,
	"./Group 614.png": 354,
	"./Group 614@2x.png": 355,
	"./Group 693.png": 356,
	"./Group 702.png": 357,
	"./Group 953.png": 358,
	"./Group 953@2x.png": 359,
	"./Group-146-Yono-mitc.png": 360,
	"./Group-146-Yono-mitc@2x.png": 361,
	"./Group-146-Yono.png": 362,
	"./Group-146-Yono@2x.png": 363,
	"./Group-146.png": 364,
	"./Group-146@2x.png": 365,
	"./Group-146TataNeu.png": 366,
	"./Group-146TataNeu@2x.png": 367,
	"./Group-3406_blue.png": 368,
	"./Group-3406_blue@2x.png": 369,
	"./Group-3406_blue_Tata.png": 370,
	"./Group-3406_blue_Tata@2x.png": 371,
	"./Group-3406_yono.png": 372,
	"./Group-3406_yono@2x.png": 373,
	"./Group-6-Yono-mitc.png": 374,
	"./Group-6-Yono-mitc@2x.png": 375,
	"./Group-6-Yono.png": 376,
	"./Group-6-Yono@2x.png": 377,
	"./Group-7.png": 378,
	"./Group-8.png": 379,
	"./Group-8@2x.png": 380,
	"./Group1043.png": 381,
	"./Group1043@2x.png": 382,
	"./Group1268-tata-neu.png": 383,
	"./Group1268-tata-neu@2x.png": 384,
	"./Group1268-yono.png": 385,
	"./Group1268-yono@2x.png": 386,
	"./Group1268.png": 387,
	"./Group1268@2x.png": 388,
	"./Group1278Tata.png": 389,
	"./Group1278Tata@2x.png": 390,
	"./Group1288.png": 391,
	"./Group1288@2x.png": 392,
	"./Group1295.png": 393,
	"./Group1295@2x.png": 394,
	"./Group1483.png": 395,
	"./Group1483@2x.png": 396,
	"./Group1489.png": 397,
	"./Group1489@2x.png": 398,
	"./Group1497-Rotate.png": 399,
	"./Group1497-Rotate@2x.png": 400,
	"./Group1497-Rotate@3x.png": 401,
	"./Group1497-TataNeu.png": 402,
	"./Group1497-TataNeu@2x.png": 403,
	"./Group1497-TataNeu@3x.png": 404,
	"./Group1497-Yono.png": 405,
	"./Group1497-Yono2.png": 406,
	"./Group1497-Yono2@2x.png": 407,
	"./Group1497-Yono2@3x.png": 408,
	"./Group1497-Yono@2x.png": 409,
	"./Group1497-Yono@3x.png": 410,
	"./Group1497.png": 411,
	"./Group1497@2x.png": 412,
	"./Group1497@3x.png": 413,
	"./Group1497TataNeu.png": 414,
	"./Group1497TataNeu@2x.png": 415,
	"./Group1497TataNeu@3x.png": 416,
	"./Group1540.png": 417,
	"./Group1540@2x.png": 418,
	"./Group1551.png": 419,
	"./Group1551@2x.png": 420,
	"./Group1624.png": 421,
	"./Group1624@2x.png": 422,
	"./Group1625.png": 423,
	"./Group1625@2x.png": 424,
	"./Group1626.png": 425,
	"./Group1626@2x.png": 426,
	"./Group1627.png": 427,
	"./Group1627@2x.png": 428,
	"./Group1628.png": 429,
	"./Group1628@2x.png": 430,
	"./Group1633.png": 431,
	"./Group1633@2x.png": 432,
	"./Group167.png": 433,
	"./Group167@2x.png": 434,
	"./Group1748.png": 129,
	"./Group1748@2x.png": 435,
	"./Group2131-tata-neu.png": 436,
	"./Group2131-tata-neu@2x.png": 437,
	"./Group2131-yono.png": 438,
	"./Group2131-yono@2x.png": 439,
	"./Group2131.png": 440,
	"./Group2131@2x.png": 441,
	"./Group2830.png": 442,
	"./Group2830@2x.png": 443,
	"./Group316.png": 444,
	"./Group316@2x.png": 445,
	"./Group332.png": 446,
	"./Group332@2x.png": 447,
	"./Group3398-tata-neu.png": 448,
	"./Group3398-tata-neu@2x.png": 449,
	"./Group3398-tata-neu@3x.png": 450,
	"./Group3398.png": 451,
	"./Group3398@2x.png": 452,
	"./Group3398@3x.png": 453,
	"./Group380.png": 454,
	"./Group380@2x.png": 455,
	"./Group411.png": 456,
	"./Group449.png": 457,
	"./Group449@2x.png": 458,
	"./Group451.png": 459,
	"./Group451@2x.png": 460,
	"./Group457.png": 461,
	"./Group457@2x.png": 462,
	"./Group47.png": 463,
	"./Group470.png": 464,
	"./Group470@2x.png": 465,
	"./Group47@2x.png": 466,
	"./Group485.png": 467,
	"./Group485@2x.png": 468,
	"./Group5.png": 469,
	"./Group502-Yono.png": 470,
	"./Group502-Yono@2x.png": 471,
	"./Group502-tata-neu.png": 472,
	"./Group502-tata-neu@2x.png": 473,
	"./Group502.png": 474,
	"./Group502@2x.png": 475,
	"./Group510.png": 476,
	"./Group510@2x.png": 477,
	"./Group514-Yono.png": 478,
	"./Group514-Yono@2x.png": 479,
	"./Group514.png": 480,
	"./Group514@2x.png": 481,
	"./Group517.png": 482,
	"./Group517@2x.png": 483,
	"./Group5@2x.png": 484,
	"./Group607.png": 485,
	"./Group607@2x.png": 486,
	"./Group621.png": 487,
	"./Group621@2x.png": 488,
	"./Group625.png": 489,
	"./Group625@2x.png": 490,
	"./Group630.png": 491,
	"./Group630@2x.png": 492,
	"./GroupCVV -4.png": 493,
	"./GroupCVV -4@2x.png": 494,
	"./Group_3406_blue.png": 495,
	"./Group_3406_blue@2x.png": 496,
	"./GstOptionScreen.png": 497,
	"./GstOptionScreen@2x.png": 498,
	"./Mask Group 1.png": 499,
	"./Mask Group 11-Tata.png": 500,
	"./Mask Group 11-Tata@2x.png": 501,
	"./Mask Group 11.png": 502,
	"./Mask Group 11@2x.png": 503,
	"./Mask Group 1@2x.png": 504,
	"./Mask Group 6.png": 505,
	"./Mask Group 6@2x.png": 506,
	"./Mask Group 7.png": 507,
	"./Mask Group 7@2x.png": 508,
	"./Mask Group 8.png": 509,
	"./Mask Group 8@2x.png": 510,
	"./Mask Group Error 6.png": 511,
	"./Mask Group Error 6@2x.png": 512,
	"./Mask Group-1.png": 513,
	"./Mask-Group-11-Tata.png": 514,
	"./Mask-Group-11-Tata@2x.png": 515,
	"./Mask-Group-11-Yono.png": 516,
	"./Mask-Group-11-Yono@2x.png": 517,
	"./MaskGroup5.png": 518,
	"./MaskGroup5@2x.png": 519,
	"./Path -1.png": 520,
	"./Path -1@2x.png": 521,
	"./Path -2.png": 522,
	"./Path -21.png": 523,
	"./Path -21@2x.png": 524,
	"./Path -2@2x.png": 525,
	"./Path -3.png": 526,
	"./Path -3@2x.png": 527,
	"./Path -5.png": 528,
	"./Path -5@2x.png": 529,
	"./Path 477.png": 530,
	"./Path 477@2x.png": 531,
	"./Path1221.png": 532,
	"./Path1221@2x.png": 533,
	"./Path1223.png": 534,
	"./Path1223@2x.png": 535,
	"./Path1669-Yono.png": 536,
	"./Path1669-Yono@2x.png": 537,
	"./Path1669-tata-neu.png": 538,
	"./Path1669-tata-neu@2x.png": 539,
	"./Path1669.png": 540,
	"./Path1669@2x.png": 541,
	"./Path426.png": 542,
	"./Path426@2x.png": 543,
	"./Path509.png": 544,
	"./Path509@2x.png": 545,
	"./Path510.png": 546,
	"./Path510@2x.png": 547,
	"./Path671.png": 548,
	"./Path671@2x.png": 549,
	"./Rectangle -5.png": 550,
	"./Rectangle -6.png": 551,
	"./Rectangle 1655-tata-neu.png": 552,
	"./Rectangle 1655.png": 553,
	"./Rectangle 22.png": 554,
	"./Rectangle 223@2x.png": 555,
	"./Rectangle 224.png": 556,
	"./Rectangle 224@2x.png": 557,
	"./Rectangle 2627.png": 558,
	"./Rectangle 2628.png": 559,
	"./Rectangle-1655-Tata.png": 560,
	"./Rectangle-1655-Yono.png": 561,
	"./Rectangle-2.png": 562,
	"./Rectangle-22-yono.png": 563,
	"./Rectangle-2@2x.png": 564,
	"./Rectangle163.png": 565,
	"./Rectangle163@2x.png": 566,
	"./Rectangle223.png": 567,
	"./SBIYonoLogo.png": 568,
	"./Sprint-Yono.png": 569,
	"./Sprint-Yono@2x.png": 570,
	"./Sprint.png": 571,
	"./Sprint@2x.png": 572,
	"./Sprint_mob.png": 573,
	"./Sprint_mob@2x.png": 574,
	"./Swift.png": 575,
	"./Swift@2x.png": 576,
	"./Swift_mob.png": 577,
	"./Swift_mob@2x.png": 578,
	"./VkycLoaderScreen.png": 579,
	"./VkycLoaderScreen@2x.png": 580,
	"./account.png": 581,
	"./account@2x.png": 582,
	"./accountAggregatorStatus.png": 583,
	"./accountAggregatorStatus@2x.png": 584,
	"./addOnBenefitshelp.png": 585,
	"./addOnBenefitshelp@2x.png": 586,
	"./addOnBenefitshelpHighlight.png": 587,
	"./addOnBenefitshelpHighlight@2x.png": 588,
	"./addOnBenefitshelpMobileHighlight.png": 589,
	"./addOnBenefitshelpMobileHighlight@2x.png": 590,
	"./appstore.png": 591,
	"./arrowForwardHelp.png": 592,
	"./arrowForwardHelp@2x.png": 593,
	"./arrowForwardHelpHighlight.png": 594,
	"./arrowForwardHelpHighlight@2x.png": 595,
	"./arrow_blue-tata-neu.png": 596,
	"./arrow_blue.png": 597,
	"./arrow_down.png": 598,
	"./arrow_forward_black-1.png": 599,
	"./arrow_forward_black-1@2x.png": 600,
	"./arrow_forward_black-2.png": 601,
	"./arrow_forward_black-2@2x.png": 602,
	"./arrow_forward_black_-19.png": 603,
	"./arrow_forward_black_-19@2x.png": 604,
	"./arrow_forward_black_-7.png": 605,
	"./arrow_forward_black_-7@2x.png": 606,
	"./arrow_forward_black_24dp.png": 607,
	"./arrow_forward_black_24dp@2x.png": 608,
	"./arrow_forward_blue-tata-neu.png": 609,
	"./arrow_forward_blue-tata-neu@2x.png": 610,
	"./arrow_forward_blue.png": 611,
	"./arrow_forward_blue@2x.png": 612,
	"./arrow_forward_blue_24dp.png": 613,
	"./arrow_forward_blue_24dp@2x.png": 614,
	"./arrow_forward_yono.png": 615,
	"./arrow_forward_yono@2x.png": 616,
	"./arrow_gst_yono.png": 617,
	"./bankVerificationhelp.png": 618,
	"./bankVerificationhelp@2x.png": 619,
	"./bankVerificationhelpHighlight.png": 620,
	"./bankVerificationhelpHighlight@2x.png": 621,
	"./bankVerificationhelpMobileHighlight.png": 622,
	"./bankVerificationhelpMobileHighlight@2x.png": 623,
	"./bottom_mobile_banner_SimplyCLICK.png": 624,
	"./bottom_web_banner_SimplyCLICK.png": 625,
	"./browseSamll.png": 626,
	"./browseSamllYono.png": 627,
	"./cameraSmall.png": 628,
	"./cameraSmallYono.png": 629,
	"./cardActivationhelp.png": 630,
	"./cardActivationhelp@2x.png": 631,
	"./cardActivationhelpHighlight.png": 632,
	"./cardActivationhelpHighlight@2x.png": 633,
	"./cardActivationhelpMobileHighlight.png": 634,
	"./cardActivationhelpMobileHighlight@2x.png": 635,
	"./checkbox-checked-tata-neu.png": 636,
	"./checkbox-checked-tata-neu@2x.png": 637,
	"./checkbox-checked-yono.png": 638,
	"./checkbox-checked-yono@2x.png": 639,
	"./checkbox-checked.png": 640,
	"./checkbox-checked@2x.png": 641,
	"./checkbox-checked_grey.png": 642,
	"./checkbox-checked_grey@2x.png": 643,
	"./checkbox-unchecked-tata-neu.png": 644,
	"./checkbox-unchecked-tata-neu@2x.png": 645,
	"./checkbox-unchecked-yono.png": 646,
	"./checkbox-unchecked-yono@2x.png": 647,
	"./checkbox-unchecked.png": 648,
	"./checkbox-unchecked@2x.png": 649,
	"./city.png": 650,
	"./city@2x.png": 651,
	"./close_black_-1.png": 652,
	"./close_black_-1@2x.png": 653,
	"./credit-card@2x.png": 654,
	"./credit.png": 655,
	"./credit@2x.png": 656,
	"./debit.png": 657,
	"./debit@2x.png": 658,
	"./digiConsent.png": 659,
	"./digiConsent@2x.png": 660,
	"./digiPage.png": 661,
	"./digiPage@2x.png": 662,
	"./digiSuccess.png": 663,
	"./digiSuccess@2x.png": 664,
	"./digiTimeout.png": 665,
	"./digiTimeout@2x.png": 666,
	"./email.png": 667,
	"./email@2x.png": 668,
	"./epfoValidateOTP.png": 669,
	"./epfoValidateOTP@2x.png": 670,
	"./error.png": 671,
	"./error@2x.png": 672,
	"./error_outline_black_24dp.png": 673,
	"./error_outline_black_24dp@2x.png": 674,
	"./gender.png": 675,
	"./gender@2x.png": 676,
	"./giftVoucher.png": 677,
	"./giftVoucher@2x.png": 678,
	"./guideToInstantCardhelp.png": 679,
	"./guideToInstantCardhelp@2x.png": 680,
	"./guideToInstantCardhelpHighlight.png": 681,
	"./guideToInstantCardhelpHighlight@2x.png": 682,
	"./guideToInstantCardhelpMobileHighlight.png": 683,
	"./guideToInstantCardhelpMobileHighlight@2x.png": 684,
	"./happy_to_help_slide_1.png": 685,
	"./happy_to_help_slide_2.png": 686,
	"./happy_to_help_slide_3.png": 687,
	"./happy_to_help_slide_4.png": 688,
	"./help_outline_black_24dp.png": 689,
	"./help_outline_black_24dp@2x.png": 690,
	"./icon_cloudDocument.png": 691,
	"./icon_cloudDocument@2x.png": 692,
	"./incomeSurrogate.png": 693,
	"./incomeSurrogate@2x.png": 694,
	"./info-svgrepo-com.png": 695,
	"./instantECardUsagehelp.png": 696,
	"./instantECardUsagehelp@2x.png": 697,
	"./instantECardUsagehelpHighlight.png": 698,
	"./instantECardUsagehelpHighlight@2x.png": 699,
	"./instantECardUsagehelpMobileHighlight.png": 700,
	"./instantECardUsagehelpMobileHighlight@2x.png": 701,
	"./kycDetails.png": 702,
	"./kycDetails@2x.png": 703,
	"./kycVerificationhelp.png": 704,
	"./kycVerificationhelp@2x.png": 705,
	"./kycVerificationhelpHighlight.png": 706,
	"./kycVerificationhelpHighlight@2x.png": 707,
	"./kycVerificationhelpMobileHighlight.png": 708,
	"./kycVerificationhelpMobileHighlight@2x.png": 709,
	"./landingPage.png": 710,
	"./landingPage@2x.png": 711,
	"./logo.png": 712,
	"./logo@2x.png": 713,
	"./logo@3x.png": 714,
	"./mobile_banner_onboarding.png": 715,
	"./officeaddress.png": 716,
	"./officeaddress@2x.png": 717,
	"./otpview.png": 718,
	"./otpview@2x.png": 719,
	"./pan.png": 65,
	"./pan@2x.png": 720,
	"./pdf_icon.png": 721,
	"./pdf_icon1.png": 130,
	"./penyFailure.png": 722,
	"./penyFailure@2x.png": 723,
	"./penySuccess.png": 724,
	"./penySuccess@2x.png": 725,
	"./penydrop.png": 726,
	"./penydrop@2x.png": 727,
	"./personalDetails.png": 728,
	"./personalDetails@2x.png": 729,
	"./personalDetailshelp.png": 730,
	"./personalDetailshelp@2x.png": 731,
	"./personalDetailshelpHighlight.png": 732,
	"./personalDetailshelpHighlight@2x.png": 733,
	"./personalDetailshelpMobileHighlight.png": 734,
	"./personalDetailshelpMobileHighlight@2x.png": 735,
	"./pfd_icon1@2x.png": 736,
	"./playstore.png": 737,
	"./professional.png": 738,
	"./professional@2x.png": 739,
	"./professionalDetailshelp.png": 740,
	"./professionalDetailshelp@2x.png": 741,
	"./professionalDetailshelpHighlight.png": 742,
	"./professionalDetailshelpHighlight@2x.png": 743,
	"./professionalDetailshelpMobileHighlight.png": 744,
	"./professionalDetailshelpMobileHighlight@2x.png": 745,
	"./resiaddress.png": 746,
	"./resiaddress@2x.png": 747,
	"./retake.png": 748,
	"./retakeTataNeu.png": 749,
	"./retakeYono.png": 750,
	"./retakeYono@2x.png": 751,
	"./rewardMobTest.png": 752,
	"./takePhoto.png": 753,
	"./takePhoto@2x.png": 754,
	"./top_mobile_banner_SimplyCLICK.png": 755,
	"./top_web_banner_SimplyCLICK.png": 756,
	"./validateEcardOTP.png": 757,
	"./validateEcardOTP@2x.png": 758,
	"./validateOTP.png": 759,
	"./validateOTP@2x.png": 760,
	"./vertical_back.png": 761,
	"./vkycOptionScreen.png": 762,
	"./vkycOptionScreen@2x.png": 763,
	"./web_banner_onboarding.png": 764,
	"./wip.png": 765,
	"./wip@2x.png": 766,
	"./woman.png": 767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;